export default "__VITE_ASSET__hjpFZcQ7__"